import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import HomePage from '@/views/HomePage.vue'
import AccessibilityPage from '@/views/AccessibilityPage.vue'
import InquiryPage from '@/views/InquiryPage.vue'

const routes = [
    {
        path: '/',
        component: DefaultLayout, // 共通レイアウト
        children: [
            {
                path: '',
                name: 'Home',
                component: HomePage,
                meta: { title: '問合せフォーム', footer: 'on' }
            },
            {
                path: '/accessibility',
                name: 'Accessibility',
                component: AccessibilityPage,
                meta: { title: 'ウェブアクセシビリティ方針'}
            },
            {
                path: '/inquiry',
                name: 'Inquiry',
                component: InquiryPage,
                meta: { title: '問合せフォーム', footer: 'on' }
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
